import(/* webpackMode: "eager", webpackExports: ["default"] */ "/lexoya/src/views/products/MonitoringPage.tsx");
